import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

import { popover } from 'components/frontend/popover';

popover();